export const PROVINCES_NUMBER = 24
export const ID_CARD_LENGTH = 10
export const RUC_LENGTH = 13